import { render, staticRenderFns } from "./AutoShiftLoading.vue?vue&type=template&id=50ce826c&lang=pug"
import script from "./AutoShiftLoading.vue?vue&type=script&lang=ts"
export * from "./AutoShiftLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports